/**
 * 지오메트리 조립 유틸(절차 배경/가구). 박스를 회전·이동해 만들고, 머티리얼별로 병합해
 * 드로우콜을 억제한다.
 */
import * as THREE from 'three';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';

/** 병합용 박스 지오메트리(회전 ry → 이동 순으로 적용 후 반환). */
export function boxGeo(
  w: number,
  h: number,
  d: number,
  x: number,
  y: number,
  z: number,
  ry = 0,
): THREE.BufferGeometry {
  const g = new THREE.BoxGeometry(w, h, d);
  if (ry !== 0) g.rotateY(ry);
  g.translate(x, y, z);
  return g;
}

/** 지오메트리 목록을 1개 메시로 병합(원본은 해제). 배경용이라 그림자 캐스팅 없음. */
export function merged(geos: THREE.BufferGeometry[], mat: THREE.Material): THREE.Mesh {
  const mesh = new THREE.Mesh(mergeGeometries(geos), mat);
  for (const g of geos) g.dispose();
  mesh.castShadow = false;
  return mesh;
}
